export default "__VITE_ASSET__Drjf_Ne9__"